import { Component, Host, h, Prop } from "@stencil/core";
/**
 * @slot image - insert the image element
 */

@Component({
    tag: "ux-iws-content-header",
    styleUrl: "content-header.scss",
    shadow: false,
})
export class ContentHeader {
    private baseClass = "ux-iws-content-header";

    /** the headline of the module */
    @Prop() headline: string = null;
    /** if set, the content box will be aligned to the left. */
    @Prop() boxLeft?: boolean = false;

    render() {
        return (
            <Host
                class={{
                    [this.baseClass]: true,
                }}
            >
                <slot name="image" />
                <slot name="badge" />
                <div
                    class={{
                        [`${this.baseClass}__box ux-col-md-10 ux-u-mx-md-auto`]: true,
                        [`${this.baseClass}__box--left ux-col-xl-4`]: this
                            .boxLeft,
                    }}
                >
                    <div
                        class={{
                            [`ux-col-md-10 ux-u-mx-auto`]: true,
                            [`ux-col-md-12`]: this.boxLeft,
                        }}
                    >
                        <h1 class="headline-big ux-u-mb-xxxs">
                            {this.headline}
                        </h1>
                        <slot name="text" />
                        <slot name="cta" />
                    </div>
                </div>
            </Host>
        );
    }
}
